// tools function
export default {

  // let size = await imageSize(file)
  // `{$size.width} × {$size.height} `
  size(file) {
    return new Promise (function (resolved, rejected) {
      var i = new Image()
      i.onload = function(){
        resolved({width: i.width, height: i.height, box: i.width == i.height, vertical: i.width < i.height})
      };
      i.src = file
    })
  },

  valid(data) {
    return new Promise (function (resolved, rejected) {
      var i = new Image()
      i.onload = function(){
        resolved(true)
      };
      i.src = data
    })
  },
  
  is(filename) {
    if (!filename) return
    let ext = filename.split('.').pop();
    switch (ext) {
      case 'jpg': 
      case 'jpeg':
      case 'png': 
      case 'webp':
      case 'gif': return true          
      default: return
    }
  },
  

}